/**
 * Returns Gov-Test-Scenario header if configured and not in production
 * Priority: localStorage > environment variable
 */
export function getTestScenarioHeader(): Record<string, string> {
    // Check if the environment is 'production' OR 'prod'
    const isProduction = import.meta.env.VITE_ENV === "production" || import.meta.env.VITE_ENV === "prod";

    if (isProduction) return {};

    // Check localStorage first (can be changed without restart),
    // then fall back to env variable (requires restart)
    let scenario: string | null = null;

    if (typeof window !== "undefined") {
        scenario = localStorage.getItem("hmrc-test-scenario");
    }

    // Fall back to env if localStorage is empty
    if (!scenario) {
        scenario = import.meta.env.VITE_HMRC_GOV_TEST_SCENARIO || null;
    }

    if (scenario) {
        return { "x-gov-test-scenario": scenario };
    }

    return {};
}
